var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import { Prop } from 'vue-property-decorator';
import VideoItem from './VideoItem';
import Pager from '../components/Pager';
import { IDomState } from '../../store/DomState';
import { DtEid } from '../../../common/reporter';
let SubscribeItem = class SubscribeItem extends VueType {
    constructor() {
        super(...arguments);
        this.pageIndex = 0;
        this.renderIndexs = {
            firstIndex: 0,
            lastIndex: 0,
        };
    }
    get pagerOption() {
        const { domState, sub } = this;
        return {
            count: sub.vs.length,
            pageSize: domState.showNum,
        };
    }
    onPageChange({ firstIndex, lastIndex }) {
        Object.assign(this.renderIndexs, { firstIndex, lastIndex });
    }
    // 关注对象是否为创作号类型
    get isCreator() {
        return this.sub.user_type === 'USER_TYPE_CREATOR';
    }
    get url() {
        return this.isCreator ? `/biu/creator/home/?vcuid=${this.sub.uin}` : `/s/videoplus/${this.sub.uin}`;
    }
    get subscribeText() {
        if (this.isCreator) {
            return this.sub.isSub ? '已订阅' : '订阅';
        }
        return this.sub.isSub ? '已关注' : '关注';
    }
    render() {
        return <div class="sub_item ">
            <div class="sub_item_header">
                <a href={this.url} target="_blank" dt-eid={DtEid.CREATOR_PORTRAIT} dt-params={`title=${this.sub.nick}`}>
                    <img class={this.isCreator ? 'sub_item_creator_avatar' : 'sub_item_avater'} v-avatar-src={this.sub.avatar}></img>
                </a>
                <div class="sub_item_top">
                    <a href={this.url} target="_blank" class="sub_item_name">{this.sub.nick}</a>
                    <button class={this.sub.isSub ? 'sub_item_btn' : 'sub_item_cancel'} data-uin={this.sub.uin} data-sub={this.sub.isSub ? '1' : '0'} data-iscreator={this.isCreator ? '1' : '0'} dt-eid={DtEid.BUTTON} dt-params={`status=${this.sub.isSub ? 0 : 1}&mod_id=subscribe`}>
                        {!this.sub.isSub && <img class="icon_add" src="//puui.qpic.cn/vupload/0/1573803614059_dsqk88stwvi.png/0"></img>}
                        {this.subscribeText}
                    </button>
                </div>
                <p class="sub_item_desc"></p>
                <Pager class="sub_pager" v-model={this.pageIndex} option={this.pagerOption} onPageChange={this.onPageChange}></Pager>
            </div>
            <div>
                {this.sub.vs.map((item, index) => <VideoItem data={item} index={index} renderIndexs={this.renderIndexs} key={index}></VideoItem>)}
            </div>
        </div>;
    }
};
__decorate([
    Prop()
], SubscribeItem.prototype, "sub", void 0);
__decorate([
    IDomState
], SubscribeItem.prototype, "domState", void 0);
SubscribeItem = __decorate([
    Component
], SubscribeItem);
export default SubscribeItem;
